import React, { useState, useEffect } from "react";
import Axios from "axios";
import { IAmenitiesFilterProps, IAmenityAPI } from "./AmenitiesFilterProps";
import Form from "react-bootstrap/Form";
import Dropdown from "react-bootstrap/Dropdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FilterDropdown } from "./AmenitiesFilterHelpers";
import { guestServiceProvider } from "../../../../../services/ServiceProvider";

const AmenitiesFilter: React.FC<IAmenitiesFilterProps> = ({
  crsCodes,
  amenities,
  handleAmenitiesChange,
}) => {
  const [_isLoading, setIsLoading] = useState(true);
  const [filters, setFilters] = useState<IAmenityAPI[]>([]);

  useEffect(() => {
    const source = Axios.CancelToken.source();
    let didCancel = false;
    (async () => {
      if (!didCancel && crsCodes && crsCodes !== null) {
        setIsLoading(true);
        try {
          const guestService = await guestServiceProvider();
          const data = await guestService.searchHotelsAmenities(crsCodes);
          const amenitiesFilterResult = [
            ...(data.searchHotelsAmenitiesByHotelCodes?.results ?? []),
          ];
          if (!didCancel) {
            setFilters(amenitiesFilterResult);
            const newFilterKeys = new Set(
              amenitiesFilterResult.map((filter) => filter.machineName)
            );
            Object.keys(amenities).forEach((key) => {
              if (!newFilterKeys.has(key)) {
                handleAmenitiesChange &&
                  handleAmenitiesChange({ key }, "delete");
              }
            });
          }
        } catch (error) {
          console.error("Error fetching amenities", error);
        } finally {
          if (!didCancel) {
            setIsLoading(false);
          }
        }
      }
    })();
    return () => {
      didCancel = true;
      source.cancel("Request cancelled for amenity filters.");
    };
  }, [crsCodes, amenities]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const method = event.target.checked ? "add" : "delete";
    handleAmenitiesChange(
      { key: event.target.name, value: event.target.value },
      method
    );
  };

  const amenityCount = Object.keys(amenities).length;

  return (
    <FilterDropdown>
      <Dropdown.Toggle variant="filter-dropdown" id="dropdown-amenities">
        <span>{`Amenities: ${amenityCount} selected`}</span>
        <FontAwesomeIcon icon="chevron-down" />
      </Dropdown.Toggle>
      <Dropdown.Menu as={`ul`} className="p-3">
        {Array.isArray(filters) &&
          filters.map((filter: IAmenityAPI) => (
            <li key={filter.machineName}>
              <Form.Check
                name={filter.machineName}
                value={filter.id}
                type="checkbox"
                label={`${filter.name} (${filter.count})`}
                id={`amenity-${filter.machineName}`}
                onChange={handleChange}
                checked={!!amenities[filter.machineName]}
              />
            </li>
          ))}
      </Dropdown.Menu>
    </FilterDropdown>
  );
};

export default AmenitiesFilter;
